import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../../Forms/MdmFormProps";
import { useResolveGeoCoordinates } from "../../../GoogleMaps/useResolveGeoCoordinates";
import { CountrySelect } from "../../../Locations/CountrySelect";
import { Edc } from "../../Edc";
import { GeoCoordinatesAddressTextField } from "../../../Supplier/Form/GeoCoordinatesAddressTextField";
import { TextFieldInput } from "../../../Forms/TextFieldInput";
import { isNotEmpty } from "../../../Utils/strings";

export const EdcAddressForm = ({ disabledFields }: MdmFormProps) => {
  const { control, getValues, setValue } = useFormContext<Edc>();

  const { resolveGeoCoordinatesIfAddressIsComplete } = useResolveGeoCoordinates<Edc>(
    "Street",
    "ZipCode",
    "City",
    "Latitude",
    "Longitude"
  );

  return (
    <BorderedFormGrid>
      {/* FIRST ROW */}
      <Grid item xs={4}>
        <TextFieldInput name="Name" control={control} required disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="City"
          control={control}
          required
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("City"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      {/* PLACEHOLDER DEFAULT STOP TIME */}
      <Grid item xs={4} />
      {/* SECOND ROW */}
      <Grid item xs={4}>
        <TextFieldInput name="Details" control={control} disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput name="Region" control={control} disabledFields={disabledFields} />
      </Grid>
      {/* PLACEHOLDER EQUIPEMENT RESTRICTION */}
      <Grid item xs={4} />
      {/* THIRD ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="Street"
          control={control}
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("Street"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <CountrySelect control={control} name="CountryId" required />
      </Grid>
      {/* PLACEHOLDER */}
      <Grid item xs={4} />
      {/* FOURTH ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="ZipCode"
          control={control}
          label="Postcode"
          required
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("ZipCode"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      {/* PLACEHOLDER ISO COUNTRY CODE */}
      <Grid item xs={4} />
      <Grid item xs={4} />
      {/* FIFTH ROW */}
      <Grid item xs={4}>
        <TextFieldInput
          name="ZipArea"
          control={control}
          label="Postcode Area"
          required
          disabledFields={disabledFields}
        />
      </Grid>
      {/* PLACEHOLDER TIMEZONE */}
      <Grid item xs={4} />
    </BorderedFormGrid>
  );
};
